import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager, useAuth } from './AuthContext';

const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const { refreshUser } = useAuth();

    useEffect(() => {
        let isHandled = false;
        userManager.signinRedirectCallback()
            .then(async () => {
                if (!isHandled) {
                    isHandled = true;
                    await refreshUser();
                    navigate('/');
                }
            })
            .catch(() => { /* ignore duplicate error */ });
        // eslint-disable-next-line
    }, [navigate, refreshUser]);

    return <div>Signing in...</div>;
};

export default AuthCallback;
export { AuthCallback };
